import React from "react";
import "./termsAndCondition.scss";
import { Stack } from "@mui/material";
import SEO from "components/seo/SEO";

const TERMS_AND_CONDITION_DATA = [
  {
    id: 1,
    title: "TERMS & CONDITIONS",
    content: (
      <>
        <div>
          The domain name www.KRISTIVE.com (“Website”) is a site operated by
          KRISTIVE Pvt. Ltd., a company incorporated under laws of India with
          our registered office at (address) (“Company/KRISTIVE”).
        </div>
        <div>
          We understand the importance of representing one's work with quality
          and respect, and we also believe it is essential that all KRISTIVE
          users respect copyright. Whether you’re a customer, or just casually
          browsing the Website, please respect the copyright of all the works
          you see or buy on KRISTIVE.
        </div>
        <div>
          By using the services on the www.KRISTIVE.com, you are agreeing to the
          following terms of service, conditions, policies, etc. (“Terms of
          Service”) including those available by hyperlink, with KRISTIVE, which
          may be updated by us from time to time.
        </div>
        <div>
          We reserve the right to review and withdraw or amend the services
          without notice. If you do not agree with its terms, kindly do not use
          this Website.
        </div>
      </>
    ),
  },
  {
    id: 2,
    title: "CONTENT & COPYRIGHT POLICY",
    content: (
      <>
        <div>
          You understand that all information, images, pictures, data, text,
          photographs, graphics, messages, or other materials, whether publicly
          posted or privately transmitted, is the exclusive work and property of
          the person from whom such Content originated. KRISTIVE does not claim
          any permanent ownership of your Content. You retain copyright and any
          other rights you already hold in Content which you submit, post,
          upload, display, or sell on or through KRISTIVE. When you submit,
          post, upload, display, or sell Content, you grant KRISTIVE a
          perpetual, irrevocable, royalty-free, and non-exclusive (and
          sub-licensable) license to use and archive the Content in accordance
          with or as reasonably contemplated by this Agreement.
        </div>
        <div>
          KRISTIVE cannot always manually screen Content before it is displayed
          on the Website, and occasionally members may inadvertently or
          deliberately submit and display content that breaches this Agreement.
          Inappropriate Content includes, but is not limited to, Content that
          infringes the copyright or other intellectual property rights of any
          person or company, or that defames or vilifies any person, people,
          races, religion or religious group, is obscene, pornographic,
          indecent, harassing, threatening, harmful, invasive of privacy or
          publicity rights, abusive, inflammatory, or otherwise objectionable.
        </div>
      </>
    ),
  },
  {
    id: 3,
    title: "TRADEMARKS",
    content: (
      <>
        <div>
          If you use any of our trademarks in reference to our products or
          services, you must include a statement attributing that trade mark to
          us, and only after securing prior written permission from KRISTIVE to
          do so, which may be given, or refused, at its sole discretion, and
          subject to any terms or conditions it may deem fit. You must not use
          any of our trademarks in or as the whole or part of your own
          trademarks; in connection with activities, products or services which
          are not ours; in a manner which may be confusing, misleading or
          deceptive; or in a manner that disparages us or our information,
          products, or services (including this Website), or in a manner that
          implies any kind of any association/affiliation with KRISTIVE.
        </div>
      </>
    ),
  },
];

const TermsAndCondition = () => {
  return (
    <div className="terms-and-condition">
      <SEO
        title="Terms & Conditions | KRISTIVE"
        description="Familiarize yourself with KRISTIVE's terms and conditions. Read the complete terms for a smooth and transparent shopping experience."
      />
      {/* {TERMS_AND_CONDITION_DATA.map((item) => (
        <div className="single-terms" key={item.id}>
          <div className="title">{item.title}</div>
          <Stack className="content" spacing={2}>
            {item.content}
          </Stack>
        </div>
      ))} */}
      <div
        style={{
          textAlign: "center",
          fontSize: "2rem",
          fontWeight: 800,
          transition: "all 0.5s ease",
          color: "#050a30",
        }}
      >
        Terms & Conditions
      </div>
      <p>
        <strong>Last updated on:</strong> Sep 14, 2025
      </p>
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <div>
          For the purpose of these Terms and Conditions, The term "we", "us",
          "our" used anywhere on this page shall mean KRISTIVE, whose
          registered/operational office is 105, Subham Society, opp. Nandanvan
          Society, Navagam-Dindoli Surat GUJARAT 394210 . "you", "your", "user",
          "visitor" shall mean any natural or legal person who is visiting our
          website and/or agreed to purchase from us.
        </div>
        <div>
          Your use of the website and/or purchase from us are governed by
          following Terms and Conditions:
        </div>
        <div>
          The content of the pages of this website is subject to change without
          notice.
        </div>
        <div>
          Neither we nor any third parties provide any warranty or guarantee as
          to the accuracy, timeliness, performance, completeness or suitability
          of the information and materials found or offered on this website for
          any particular purpose. You acknowledge that such information and
          materials may contain inaccuracies or errors and we expressly exclude
          liability for any such inaccuracies or errors to the fullest extent
          permitted by law.
        </div>
        <div>
          Your use of any information or materials on our website and/or product
          pages is entirely at your own risk, for which we shall not be liable.
          It shall be your own responsibility to ensure that any products,
          services or information available through our website and/or product
          pages meet your specific requirements.
        </div>
        <div>
          Our website contains material which is owned by or licensed to us.
          This material includes, but are not limited to, the design, layout,
          look, appearance and graphics. Reproduction is prohibited other than
          in accordance with the copyright notice, which forms part of these
          terms and conditions.
        </div>
        <div>
          All trademarks reproduced in our website which are not the property
          of, or licensed to, the operator are acknowledged on the website.
        </div>
        <div>
          Unauthorized use of information provided by us shall give rise to a
          claim for damages and/or be a criminal offense.
        </div>
        <div>
          From time to time our website may also include links to other
          websites. These links are provided for your convenience to provide
          further information.
        </div>
        <div>
          You may not create a link to our website from another website or
          document without KRISTIVE's prior written consent.
        </div>
        <div>
          Any dispute arising out of use of our website and/or purchase with us
          and/or any engagement with us is subject to the laws of India .
        </div>
        <div>
          We, shall be under no liability whatsoever in respect of any loss or
          damage arising directly or indirectly out of the decline of
          authorization for any Transaction, on Account of the Cardholder having
          exceeded the preset limit mutually agreed by us with our acquiring
          bank from time to time
        </div>
      </div>
    </div>
  );
};

export default TermsAndCondition;
